import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { OrderSource, ORDER_SOURCE_COLORS } from '@/types/order';

interface OrderSourceBadgeProps {
  source: OrderSource;
  className?: string;
}

const OrderSourceBadge: React.FC<OrderSourceBadgeProps> = ({ source, className }) => {
  const { t } = useTranslation();

  return (
    <span
      className={classNames(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        ORDER_SOURCE_COLORS[source],
        className
      )}
    >
      {t(`orders.source.${source}`)}
    </span>
  );
};

export default OrderSourceBadge;
